import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { styled } from "@mui/system";
import { Link as ScrollLink } from "react-scroll";
import image1 from "../../Assets/1.webp";
import image2 from "../../Assets/2.webp";
import image3 from "../../Assets/3.webp";
import image4 from "../../Assets/4.webp";
import image5 from "../../Assets/5.webp";
import image6 from "../../Assets/6.webp";
import image7 from "../../Assets/7.webp";
import image8 from "../../Assets/8.webp";
import AOS from 'aos';  // Import AOS
import 'aos/dist/aos.css'; // Import AOS styles


const images = [
  image3,
  image2,
  image5,
  image4,
  image1,
  image6,
  image7,
  image8,
];

const BackgroundWrapper = styled(Box)({
  position: "relative",
  width: "100%",
  height: "100vh",
  overflow: "hidden",
});

const BackgroundImage = styled(Box)(({ backgroundImage }) => ({
  position: "relative", // Ensure the pseudo-element positions correctly
  width: "100%",
  height: "100%",
  backgroundImage: `url(${backgroundImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  animation: "zoomEffect 10s infinite",
  "@keyframes zoomEffect": {
    "0%": { transform: "scale(1)" },
    "50%": { transform: "scale(1.1)" },
    "100%": { transform: "scale(1)" },
  },
  // Add a dark overlay using the pseudo-element
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.4)", // Semi-transparent black for dimming
    zIndex: 1, // Ensures it appears above the image
  },
}));

const ButtonGroup = styled(Box)({
  display: "flex",
  gap: "16px",
  marginTop: "16px",
  justifyContent: "center",
});

const Overlay = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "rgba(0, 0, 0, 0.42)",
  borderRadius: "8px",
  width: "80%",
  maxWidth: "700px",
  padding: "32px",
  textAlign: "center",
  zIndex: 2,
  color: "#fff",
  [theme.breakpoints.down("sm")]: {
    width: "90%",
    padding: "16px",
    maxWidth: "90%",
  },
}));

const TradingSection = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [preloadedImages, setPreloadedImages] = useState([]);

  useEffect(() => {
      AOS.init({ duration: 1000, once: true }); // Initialize AOS with options
    }, []);
  // Preload images
  useEffect(() => {
    const loadImages = async () => {
      const loadedImages = await Promise.all(
        images.map(
          (src) =>
            new Promise((resolve) => {
              const img = new Image();
              img.src = src;
              img.onload = () => resolve(src);
            })
        )
      );
      setPreloadedImages(loadedImages);
    };

    loadImages();
  }, []);

  // Change image every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <BackgroundWrapper>
      {preloadedImages.length > 0 && (
        <BackgroundImage backgroundImage={preloadedImages[currentImage]} />
      )}
      <Overlay>
        <Typography
          variant="h6"
          textAlign="center"
          sx={{
            letterSpacing: "2px",
            marginBottom: "16px",
            fontSize: { xs: "14px", sm: "16px" },
            fontFamily: "'Montserrat', sans-serif",
          }}
          data-aos="fade-up"
        >
          WELCOME TO
        </Typography>
        <Typography
          variant="h2"
          textAlign="center"
          fontWeight="bold"
          sx={{
            color: "#98AF41",
            marginBottom: "16px",
            fontSize: { xs: "54px", sm: "66px" },
          }}
          data-aos="fade-up"
        >
          <b>CGL TRADING</b>
        </Typography>
        <Typography
          variant="h5"
          textAlign="center"
          sx={{
            marginBottom: "16px",
            fontSize: { xs: "18px", sm: "24px" },
            fontFamily: "'Montserrat', sans-serif",
          }}
          
        >
          <b>FOOD TRADING COMPANY IN DUBAI</b>
        </Typography>
        <Typography
          variant="body1"
          textAlign="center"
          sx={{
            marginBottom: "32px",
            fontSize: { xs: "12px", sm: "16px" },
            fontFamily: "'Montserrat', sans-serif",
          }}
        >
          Exporter & Importer Of Pulses, Grains, & Dry Fruits Food Products
        </Typography>
        <ButtonGroup>
          <Button
            component={ScrollLink}
            to="products"
            smooth
            offset={-70}
            duration={500}
            variant="outlined"
            color="inherit"
            sx={{
              borderColor: "#fff",
              color: "#fff",
              fontSize: { xs: "12px", sm: "14px" },
              ":hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
            }}
          >
            PRODUCTS
          </Button>
          <Button
            component={ScrollLink}
            to="aboutus"
            smooth
            offset={-70}
            duration={500}
            variant="outlined"
            color="inherit"
            sx={{
              borderColor: "#fff",
              color: "#fff",
              fontSize: { xs: "12px", sm: "14px" },
              ":hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
            }}
          >
            MORE ABOUT US
          </Button>
        </ButtonGroup>
        <Typography
          variant="body2"
          textAlign="center"
          sx={{
            marginTop: "32px",
            fontSize: { xs: "10px", sm: "12px" },
            fontFamily: "'Montserrat', sans-serif",
          }}
        >
          CGL General Trading LLC is a leading food trading company in Dubai,
          specializing in the export and import of food products like pulses,
          grains, and dry fruits. With over two decades of experience in the UAE
          market, we have built a reputation for providing superior quality food
          products, ensuring accuracy and meeting international standards. Our
          commitment to excellence has made us a trusted name in the industry.
        </Typography>
      </Overlay>
    </BackgroundWrapper>
  );
};

export default TradingSection;
